import { render, staticRenderFns } from "./MailTemplateLookup.vue?vue&type=template&id=52b375c8&"
import script from "./MailTemplateLookup.vue?vue&type=script&lang=ts&"
export * from "./MailTemplateLookup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports